import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  // CRA inlines these at build time, so a miss here means the build ran
  // without client/.env rather than anything going wrong at runtime.
  throw new Error(
    'Missing Supabase config. Expected REACT_APP_SUPABASE_URL and ' +
      'REACT_APP_SUPABASE_PUBLISHABLE_KEY in client/.env at build time.'
  );
}

export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Magic-link logins land back on the site with tokens in the URL; this
    // reads them, establishes the session, and clears them from the address bar.
    detectSessionInUrl: true,
  },
});
